import React from "react";
import { Modal, useNotifications } from "sprint-common-web";

import { CourseOfActionReference } from "../../../../common/types/CourseOfActionReference";
import { FixedBillingReference } from "../../../../common/types/FixedBillingReferfence";
import { WaitingForClientResponseDetailsForm } from "../../../common/waiting-for-client-response-form/WaitingForClientResponseDetailsForm";
import { useCloudFileDashboard } from "../common/context/useCloudFileDashboard";
import { useRequestWaitingForClientResponse } from "./useRequestWaitingForClientResponse";

type CloudFileWaitingForClientResponseDialogProps = {
    cloudFileId: string;
    isOpen: boolean;
    onClose: () => void;
};

export const CloudFileWaitingForClientResponseDialog = ({
    isOpen,
    onClose,
    cloudFileId
}: CloudFileWaitingForClientResponseDialogProps): JSX.Element => {
    const { lookupFileRecordId } = useCloudFileDashboard();
    const { requestWaitingForClientResponse } = useRequestWaitingForClientResponse({
        cloudFileId,
        fileRecordId: lookupFileRecordId
    });
    const { success, error } = useNotifications();

    const handleStatusDetailsChange = async ({
        courseOfAction,
        details,
        fixedBilling
    }: {
        details: string;
        courseOfAction: CourseOfActionReference;
        fixedBilling?: FixedBillingReference;
    }) => {
        try {
            await requestWaitingForClientResponse.mutateAsync({
                cloudFileId,
                details,
                courseOfActionId: courseOfAction.id,
                fixedBillingId: fixedBilling?.id
            });

            success("Cloud file successfully changed to Waiting for Client Response");
        } catch (e) {
            console.log(e);

            error("Cloud file status change to Waiting for Client Response failed");
        }

        onClose();
    };

    return (
        <Modal
            headerText="Change cloud file status to Waiting for Client Response"
            isBlocking={true}
            isOpen={isOpen}
            onDismiss={onClose}
        >
            <WaitingForClientResponseDetailsForm onConfirm={handleStatusDetailsChange} onCancel={onClose} />
        </Modal>
    );
};
